import { Dashboard } from '@uppy/react'
import {
  DisplayMedium,
  ParagraphMedium
} from 'baseui/typography'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { theme } from '../theming'
import styles from './UploadStep.module.scss'

interface UploadStepProps {
  title: string
  description: string
  uppy: any
}

const UploadStep = ({ title, description, uppy }: UploadStepProps) => {
  const { t } = useTranslation()
  const [dashboardSize, setDashboardSize] = useState({ width: 500, height: 400 })

  useEffect(() => {
    const updateSize = () => {
      const isMobile = window.innerWidth < 768
      const isDesktop = window.innerWidth >= 1200
      const responsiveWidth = Math.max(280, window.innerWidth - 24)
      setDashboardSize({
        width: isDesktop ? 500 : responsiveWidth,
        height: isMobile ? 300 : 400
      })
    }

    updateSize()
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return (
    <>
      <div style={{ marginBottom: '24px' }}>
        <DisplayMedium
          as="h1"
          overrides={{
            Block: {
              style: {
                fontWeight: '600',
                margin: '0',
                color: theme.style.primitives.primaryA,
                textAlign: 'center'
              }
            }
          }}
        >
          {title}
        </DisplayMedium>
      </div>

      <ParagraphMedium
        overrides={{
          Block: {
            style: {
              textAlign: 'center',
              margin: '0 0 32px 0',
                color: theme.style.primitives.primaryA,
              fontSize: '16px'
            }
          }
        }}
      >
        {description}
      </ParagraphMedium>

      <div className={styles.dashboardContainer}>
        {uppy && (
          <Dashboard
            uppy={uppy}
            width={dashboardSize.width}
            height={dashboardSize.height}
            hideUploadButton={true}
            waitForThumbnailsBeforeUpload={true}
            centerSingleFile={true}
            proudlyDisplayPoweredByUppy={false}
            disableInformer={true}
            note={t('ALLOWED_FILES_NOTE')}
            plugins={['Webcam']}
          />
        )}
      </div>

    </>
  )
}

export default UploadStep
